<template>
  <div>
    <section class="hero is-success">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            {{direction.toUpperCase()}} TRIPS
          </h1>
          <h2 class="subtitle" v-if="goingFrom && goingTo">
            {{goingFrom}} to {{goingTo}}
          </h2>
          <h2 class="subtitle" v-if="routePermutation">
            <icon-segments :permutation=routePermutation></icon-segments>
          </h2>
        </div>
      </div>
    </section>

    <div class="container">
      <div class="tile is-ancestor" style="margin-top: 20px" v-if="!routePermutation">
        <div class="tile is-parent is-vertical is-6">
          <p class="title">Recommended Trips</p>
          <itinerary v-for="itin in getTopItins" v-on:add-to-cart="addToCart" :itinerary=itin></itinerary>
        </div>
        <div class="tile is-parent is-vertical is-6">
          <p class="title">
            Trips by Modes
          </p>
          <permutation-group v-for="perm in getPermutations()" v-on:click-pg="onClickPG"
                             :permutation=perm
                             :minPrice="minPricePermutationGroup(perm)">
          </permutation-group>
        </div>


      </div>

      <itineraries v-on:add-to-cart="addToCart" :itineraries="getFilteredItineraries" :direction="direction"
                   :permutation="routePermutation" v-if="routePermutation">
      </itineraries>

      <b-loading :active.sync="loading"></b-loading>
    </div>
  </div>
</template>

<script>
import PermutationGroup from './PermutationGroup';
import Itinerary from './Itinerary';
import Itineraries from './Itineraries';
import IconSegments from './IconSegments';
import axios from 'axios';
import itineraries from '../itineraries';

export default {
  name: 'Results',
  props: ['itineraries', 'direction', 'searchId', 'fromLocality', 'toLocality'],
  components: {
    'permutation-group': PermutationGroup,
    itinerary: Itinerary,
    'icon-segments': IconSegments,
    itineraries: Itineraries,
  },
  computed: {
    routePermutation() {
      return this.$route.query.permutation;
    },
    getTopItins() {
      if (this.direction === 'departing') {
        return [...this.departingItineraries].sort((a, b) => (a.total_price - b.total_price)).slice(0, 3);
      }
      return [...this.returningItineraries].sort((a, b) => (a.total_price - b.total_price)).slice(0, 3);
    },
    getItineraries() {
      if (this.direction === 'departing') return [...this.departingItineraries];
      return [...this.returningItineraries];
    },
    getFilteredItineraries() {
      return [...this.getItineraries].filter(itin => itin.permutation === this.$route.query.permutation);
    },
    goingFrom() {
      return this.direction === 'departing' ? this.fromLocality : this.toLocality;
    },
    goingTo() {
      return this.direction !== 'departing' ? this.fromLocality : this.toLocality;
    },
  },
  data() {
    return {
      departingItinerary: null,
      returingItinerary: null,
      departingItineraries: [],
      returningItineraries: [],
      itins: this.itineraries || [],
      loading: false,
    };
  },
  mounted() {
    const self = this;
    // if we have no itineraries prop, perhaps a link was shared. go fetch the results manually
    if (!this.itineraries) {
      this.loading = true;
      setTimeout(() => {

        self.itins = itineraries.data
        self.loading = false;
        self.divideItineraries();
      }, 1000);
    } else {
      this.itins = this.itineraries;
      this.divideItineraries();
    }
  },
  methods: {
    onClickPG(permutation) {
      this.$router.push({ query: { permutation } });
    },
    minPricePermutationGroup(pg) {
      return Math.min(...[...this.getItineraries].filter(x => x.permutation === pg).map(x => parseFloat(x.total_price))).toFixed(2);
    },
    getPermutations() {
      // use set to easily get unique values
      if (this.direction === 'departing') {
        return [...new Set(this.departingItineraries.map(itin => itin.permutation))];
      }
      return [...new Set(this.returningItineraries.map(itin => itin.permutation))];
    },
    alertRetrievalError() {
      const self = this;
      this.$dialog.alert({
        title: 'Error',
        message: 'We ran into problems trying to retrieve data for this search. Please create a new search.',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: _val => self.$router.push({ name: 'Search' }),
      });
    },
    divideItineraries() {
      this.departingItineraries = this.itins.filter(itin => (itin.departing_segments.length > 0));
      this.returningItineraries = this.itins.filter(itin => (itin.returning_segments.length > 0));
    },
    goToCart(query) {
      this.$router.push({
        name: 'Cart',
        params: {
          searchId: this.searchId,
          fromLocality: this.fromLocality,
          toLocality: this.toLocality,
          departingItinerary: this.departingItinerary,
          returningItinerary: this.returningItinerary,
        },
        query,
      });
    },
    addToCart(itinerary) {
      if (this.direction === 'departing') {
        this.departingItinerary = itinerary;
        if (this.returningItineraries.length > 0) {
          this.$router.push({
            name: 'Results',
            params: {
              searchId: this.searchId,
              fromLocality: this.fromLocality,
              toLocality: this.toLocality,
              direction: 'returning',
              itineraries: this.itins,
            },
            query: { departingItinerary: itinerary.id },
          });
        } else {
          this.goToCart({ departingItinerary: itinerary.id });
        }
      } else {
        this.returningItinerary = itinerary;
        this.goToCart({
          departingItinerary: this.departingItinerary ? this.departingItinerary.id : this.$route.query.departingItinerary,
          returningItinerary: itinerary.id,
        });
      }
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pg {
    margin: 2px;
    padding: 2px;
  }

  .b-tabs {
    margin-bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Results.vue